<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title"><i class="el-icon-monitor"></i> 计算机列表</div>
    <div class="main-shadow-box">
      <el-row style="margin-bottom: 10px;">
        <el-button @click="openAdd()" style="float: right" type="primary">新增</el-button>
        <el-form inline>
          <el-form-item label="所属部门">
            <el-select v-model="queryDepartmentNo" clearable>
              <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.no"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-row>
      <el-table :data="list" size="medium">
        <el-table-column prop="no" label="编号"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="ip" label="IP地址"></el-table-column>
        <el-table-column prop="departmentNo" label="部门">
          <template v-slot="scope">
            {{ scope.row.departmentNo | department_name}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template v-slot="s">{{s.row.createTime | date}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="s">
            <el-button @click="openUpdate(s.row)">修改</el-button>
            <el-button @click="openRemove(s.row)" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-dialog :visible.sync="addVisible" :computer="currentComputer"></add-dialog>
    <update-dialog :visible.sync="updateVisible" :computer="currentComputer"></update-dialog>
  </div>
</template>
<script>

import { mapActions, mapState } from "vuex";
import addDialog from './add'
import updateDialog from './update'

export default {
  components: {
    addDialog,
    updateDialog
  },
  data() {
    return {
      addVisible: false,
      updateVisible: false,
      currentComputer: {},
      queryDepartmentNo: ''
    };
  },
  watch: {
    queryDepartmentNo(v){
      this.load(this.queryDepartmentNo)
    }
  },
  computed: {
    ...mapState("computer", ["list"]),
    ...mapState("department", {deptList: state => state.list})
  },
  methods: {
    ...mapActions({load: 'computer/list'}),
    ...mapActions({loadDepts: 'department/list'}),
    ...mapActions("computer", ["remove"]),
    openUpdate(row){
      this.currentComputer = {...row}
      this.addVisible = false
      this.updateVisible = true
    },
    openAdd(){
      this.currentComputer = {
        no: "",
        name: "",
        ip: "",
        departmentNo: "",
        remark: ""
      }
      this.addVisible = true
      this.updateVisible = false
    },
    openRemove(row){
      this.$confirm(`是否确定删除 ${row.name} ？`, { type: "warning" })
        .then(() => this.remove(row.id))
        .then(() => {
          this.$message("移除成功")
        });
    }
  },
  mounted() {
    this.loadDepts()
    this.load(this.queryDepartmentNo)
  }
};
</script>
